export default __webpack_public_path__ + "static/media/fsplus-project-consultation.daff8990.png";